// extracted by mini-css-extract-plugin
module.exports = {"main":"Legal-module--main--2EPiB","title":"Legal-module--title--9ItZg","content":"Legal-module--content--2GYgG"};